import React, { Component } from 'react';
//import logo from './logo.svg';
import './App.css';
import web3 from './web3';
import lottery from './lottery';

class App extends Component {
  state = {
    manager: '',
    players: [],
    balance: '',
    value: '0.25',
    message: '',
    lastWinner: ''
  };

  async componentDidMount() {
    const manager = await lottery.methods.manager().call();
    const players = await lottery.methods.getPlayers().call();
    const balance = await web3.eth.getBalance(lottery.options.address);
    const lastWinner = await lottery.methods.lastWinner().call();

    this.setState({ manager, players, balance, lastWinner });
  }

  onSubmit = async (event) => {
    event.preventDefault();

    const accounts = await web3.eth.getAccounts();

    this.setState({ message: 'Waiting to transaction success...' });

    await lottery.methods.enter().send({
      from: accounts[0],
      value: web3.utils.toWei(this.state.value, 'ether')
    });

    this.setState({ message: 'Thank you for your ticket!' });

  };

  onClick = async (event) => {
    event.preventDefault();

    const accounts = await web3.eth.getAccounts();
    this.setState({ message: 'Waiting to transaction success...' });
    await lottery.methods.pickWinner().send({
      from: accounts[0]
    });
    const lastWinner = await lottery.methods.lastWinner().call();
    this.setState({ message: 'The new winner is: '+lastWinner });
  }


  render() {
    //web3.eth.getAccounts().then(console.log);
    return (
      <div>
        <h2>Lottery contract</h2>
        <p>This contract is managed by: {this.state.manager}.</p>
        <p>There are: {this.state.players.length} players included in the lottery.</p>
        <p>Win: {web3.utils.fromWei(this.state.balance)} Ether!</p>

        <hr />

        <form onSubmit={this.onSubmit}>
          <h4>Buy a ticket!</h4>
          <div>
            <p>One ticket will cost 0.25 Eth!</p>
            <button>Enter</button>
          </div>
        </form>

        <hr />

        <h4>Pick a winner</h4>
        <button onClick={this.onClick}>Pick a winner</button>
        <p>Last winner was: {this.state.lastWinner}</p>
        <hr />

        <h3>{this.state.message}</h3>

      </div>

    );
  }
}

export default App;
